import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DASHBOARD_ROUTE } from "../../../../routes";
import { FORMS_ROUTE } from "../../dashboard-routes";
import { formInfo } from "./form-info";
import "./forms-list.css";

const FormsList = () => {
    const [searchText, setSearchText] = useState("");
    const [displayFormInfo, setDisplayFormInfo] = useState(formInfo);
    const baseRoute = DASHBOARD_ROUTE + FORMS_ROUTE;

    useEffect(() => {
        let query = searchText.toLowerCase().replace(" ", "");
        let filteredFormInfo = formInfo.filter((form) => {
            return (
                form.formTitle.toLowerCase().replace(" ", "").includes(query) ||
                form.description.toLowerCase().includes(query)
            );
        });
        setDisplayFormInfo(filteredFormInfo);
    }, [searchText]);

    return (
        <div id="forms-list">
            <div className="container-fluid p-0">
                <div className="card p-4 m-0 no-radius border-0 border-bottom">
                    <h5>List of Forms</h5>
                    <div className="text-2">Select a form from the list or use the search bar </div>
                    <div className="d-flex align-items-center justify-content-center px-5 mt-4">
                        <div className="input-group" style={{ maxWidth: "32rem" }}>
                            <input
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                type="text"
                                className="form-control"
                                placeholder="Search for Forms"
                                aria-label="Search Field"
                                aria-describedby="basic-addon2"
                                required
                            />
                            <button className="btn btn-primary text-white">Search</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid p-3">
                <div className="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-3">
                    {displayFormInfo.map((form, i) => (
                        <div className="col" key={i}>
                            <div className="card">
                                <div className="card-body p-4">
                                    <b>{form.formTitle}</b>
                                    <p className="text-2">{form.description}</p>
                                </div>
                                <div className="card-footer text-muted text-center text-decoration-none p-0">
                                    <Link to={baseRoute + form.path}>
                                        <div className="d-flex align-items-center justify-content-center" style={{height:"3rem"}}>
                                            Open this form
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FormsList;
